import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './arrow-seek-animation.css'

@register
export class ArrowSeekAnimation extends BaseComponent {}

ArrowSeekAnimation.options = {
  className: 'vjs-x-animation-arrow-seek',
}
